// @ts-strict-ignore
import {Component, Injector, Input, OnInit} from "@angular/core";
import {BaseRecordingPlayer} from "../base-recording-player/base-recording-player";
import {AudioChannelState, ScenarioRecording} from "@models";
import {EventEmitterService} from "@event-emitter";

@Component({
	selector: "sim-scenario-recording-player",
	templateUrl: "./scenario-recording-player.component.html",
	styleUrls: ["./scenario-recording-player.component.scss"],
	providers: [EventEmitterService],
	standalone: false,
})
export class ScenarioRecordingPlayerComponent extends BaseRecordingPlayer implements OnInit {
	@Input() rootFolderIndex: number;

	constructor(injector: Injector) {
		super(injector);
	}

	public ngOnInit() {
		super.ngOnInit();
	}
}
